import { createSlice } from '@reduxjs/toolkit'
import {
    ClubListForSanctionRevenueBreakDown,
    SanctionRevenueBreakDown,
    UserListByClubForSanctionRevenueBreakDown,
    SanctionRevenueBreakDownGrandTotal
} from './thunk'

export const initialState = {
    list: [],
    clubs: {
        list: [],
        loading: true
    },
    users: {
        list: [],
        loading: false
    },
    grandTotal: {
        grand_total: '0.00',
        connected_accnt_amt: '0.00',
        master_accnt_amt: '0.00',
        loading: true
    },
    loading: true
}
const MemberShipRevenueBreakDown = createSlice({
    name: '@membership/RevenueBreakDown',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        ///
        builder.addCase(SanctionRevenueBreakDown.pending, (state) => {
            state.list = []
            state.loading = true
        })
        builder.addCase(SanctionRevenueBreakDown.fulfilled, (state, action) => {
            const { data } = action.payload
            state.list = data || []
            state.loading = false
        })
        builder.addCase(SanctionRevenueBreakDown.rejected, (state) => {
            state.list = []
            state.loading = false
        })

        //
        builder.addCase(ClubListForSanctionRevenueBreakDown.pending, (state) => {
            state.clubs.list = []
            state.clubs.loading = true
        })
        builder.addCase(ClubListForSanctionRevenueBreakDown.fulfilled, (state, action) => {
            state.clubs.list = action.payload || []
            state.clubs.loading = false
        })
        builder.addCase(ClubListForSanctionRevenueBreakDown.rejected, (state) => {
            state.clubs.list = []
            state.clubs.loading = false
        })

        //
        builder.addCase(UserListByClubForSanctionRevenueBreakDown.pending, (state) => {
            state.users.list = []
            state.users.loading = true
        })
        builder.addCase(UserListByClubForSanctionRevenueBreakDown.fulfilled, (state, action) => {
            state.users.list = action.payload || []
            state.users.loading = false
        })
        builder.addCase(UserListByClubForSanctionRevenueBreakDown.rejected, (state) => {
            state.users.list = []
            state.users.loading = false
        })
        //
        builder.addCase(SanctionRevenueBreakDownGrandTotal.pending, (state) => {
            state.grandTotal.master_accnt_amt = '0.00'
            state.grandTotal.grand_total = '0.00'
            state.grandTotal.connected_accnt_amt = '0.00'
            state.grandTotal.loading = true
        })
        builder.addCase(SanctionRevenueBreakDownGrandTotal.fulfilled, (state, { payload }) => {
            state.grandTotal.master_accnt_amt = payload.master_accnt_amt
            state.grandTotal.grand_total = payload.grand_total
            state.grandTotal.connected_accnt_amt = payload.connected_accnt_amt
            state.grandTotal.loading = false
        })
        builder.addCase(SanctionRevenueBreakDownGrandTotal.rejected, (state) => {
            state.users.list = []
            state.grandTotal.master_accnt_amt = '0.00'
            state.grandTotal.grand_total = '0.00'
            state.grandTotal.connected_accnt_amt = '0.00'
            state.grandTotal.loading = false
        })
    }
})

export default MemberShipRevenueBreakDown.reducer